/**
 * Create User Page
 */
import React from 'react';

const CreateUser = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Create User</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Add a new system user</p>
    </div>
  );
};

export default CreateUser;
